import styles from './Loading.module.css';

const TOTAL_OF_ITEMS = 20;

export function Loading() {
	return (
		<div className={styles['loading']}>
			<Topbar />
			<Sidebar />
			<Content />
		</div>
	);
}

function Topbar() {
	return (
		<nav>
			<div>
				<div className={styles['shine']} />
				<div className={styles['shine']} />
			</div>
			<div>
				<div className={styles['shine']} />
			</div>
			<div>
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
			</div>
		</nav>
	);
}

function Sidebar() {
	return (
		<aside>
			<div>
				<div className={styles['shine']} />
			</div>
			<ul>
				{Array(TOTAL_OF_ITEMS)
					.fill(0)
					.map((_, i) => (
						<Item key={i} />
					))}
			</ul>
		</aside>
	);
}

function Item() {
	return (
		<li>
			<div className={[styles['image'], styles['shine']].join(' ')} />
			<div className={styles['text']}>
				<div className={styles['shine']} />
				<div className={styles['shine']} />
			</div>
		</li>
	);
}

function Content() {
	return (
		<section>
			<div className={styles['content']}>
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
				<div className={styles['shine']} />
			</div>
		</section>
	);
}
